// extracted by mini-css-extract-plugin
export default {"digital_clock_container_container":"digital-clock-container_digital_clock_container_container__5BSfn"};